"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _filterContext = _interopRequireDefault(require("@micado-digital/react-filter/context/filterContext"));
var _ConditionalWrapper = _interopRequireDefault(require("@micado-digital/react-ui/components/ConditionalWrapper"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _de = _interopRequireDefault(require("../../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../../locals/it.json"));
var _FilterItem = _interopRequireDefault(require("./FilterItem.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const FilterItem = _ref => {
  let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  const {
    localValues,
    setLocalValues
  } = (0, _react.useContext)(_filterContext.default);
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const {
    children,
    identifier,
    label,
    lang,
    options = [],
    onSubmit
  } = props || {};
  const theme = (0, _useTheme.default)();
  const isMobile = (0, _useMediaQuery.default)(theme.breakpoints.down("sm"));
  const css = (0, _FilterItem.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const counter = (0, _react.useMemo)(() => {
    const filteredOptions = options === null || options === void 0 ? void 0 : options.filter(option => option.selected);
    return filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length;
  }, [options]);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    onSubmit();
  };
  const handleDelete = () => {
    const _localValues = JSON.parse(JSON.stringify(localValues));
    _localValues[identifier] = null;
    setLocalValues(_localValues);
    handleClose();
  };
  return /*#__PURE__*/_react.default.createElement(_ConditionalWrapper.default, {
    condition: !isMobile,
    wrapper: children => /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(css.filterItem, "mco-filter-item")
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: (0, _clsx.default)(css.button, "mco-filter-item__button", {
        "mco-filter-item__button--selected": anchorEl
      }),
      color: anchorEl ? "primary" : "default",
      variant: anchorEl ? "contained" : "outlined",
      onClick: handleClick
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _clsx.default)(css.label, "mco-filter-item__label", {
        "mco-filter-item__label--selected": anchorEl
      })
    }, label), counter > 0 && /*#__PURE__*/_react.default.createElement(_Chip.default, {
      className: (0, _clsx.default)(css.counter, "mco-filter-item__counter", {
        [css.counterSelected]: anchorEl
      }),
      label: counter,
      size: "small",
      variant: "outlined"
    }), /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      className: (0, _clsx.default)(css.icon, "mco-filter-item__icon"),
      src: "/img/icons/chevron-down.svg",
      size: 18
    })), /*#__PURE__*/_react.default.createElement(_Popover.default, {
      anchorEl: anchorEl,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      classes: {
        paper: (0, _clsx.default)(css.menu, "mco-filter-item__content")
      },
      disablePortal: true,
      getContentAnchorEl: null,
      keepMounted: true,
      open: Boolean(anchorEl),
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      onClose: handleClose
    }, children, /*#__PURE__*/_react.default.createElement(_Box.default, {
      className: "mco-filter-item__buttons",
      display: "flex",
      justifyContent: "space-between",
      mt: 1
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "mco-filter-item-button__delete",
      color: "primary",
      variant: "text",
      onClick: handleDelete
    }, l("reactShop.productOverview.filter.labels.delete")), /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "mco-filter-item-button__save",
      color: "primary",
      variant: "contained",
      onClick: handleClose
    }, l("reactShop.productOverview.filter.labels.save")))))
  }, /*#__PURE__*/_react.default.cloneElement(children, props));
};
var _default = exports.default = FilterItem;